import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityTraffic/img/1.avif';
import image2 from '@src/assets/images/solution/cityTraffic/img/2.avif';
import image3 from '@src/assets/images/solution/cityTraffic/img/3.avif';
import image4 from '@src/assets/images/solution/cityTraffic/img/4.avif';
import image5 from '@src/assets/images/solution/cityTraffic/img/5.avif';
import image6 from '@src/assets/images/solution/cityTraffic/img/6.avif';
import image7 from '@src/assets/images/solution/cityTraffic/img/7.avif';
import image8 from '@src/assets/images/solution/cityTraffic/img/8.avif';
import image9 from '@src/assets/images/solution/cityTraffic/img/9.avif';

export default {
  type: '交通ソリューション',

  banner: {
    title: 'AIベースの車両分析で、高速道路のサービスエリア駐車場をスマートに管理',
    desc: 'PTZ AIカメラで駐車区域内の車両位置とナンバープレートをリアルタイムで認識し、混雑を緩和し、運用効率を高め、利用者の体験を向上させます。',
  },

  video: {
    title: 'AI駐車分析で運用と利便性を同時に最適化',
    desc: 'AIカメラが車両位置とナンバープレートをリアルタイムで認識し、駐車スペースの利用状況を即時に表示。利用者情報と連携してスマートな運営を可能にします。',
    play: video,
  },

  func: [
    {
      theme: 'AIベースの車両追跡と環境対応',
      title: 'PTZカメラで広範囲を高精度モニタリング',
      desc: '照明タワーに設置した複数のPTZカメラを連携させ、広い駐車エリアを隙間なくカバー。必要エリアは高倍率ズームで精密監視し、駐車フローや混雑エリアをリアルタイムで追跡します。',
      sub1: 'リアルタイム状況把握',
      icon1: IconClockGray,
      sub2: '迅速なデータ連携',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: 'AIモデルを現場データで強化',
      desc: 'ORBROはリアルタイムデータ拡張技術で、駐車場現場に合わせて物体認識モデルを迅速に学習。カメラ設置後、短期間で認識率を飛躍的に向上させます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: '高い精度提供',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: '夜間・低照度でも安定認識',
      desc: '夜間や暗い照明条件でも車両の速い動きを正確に捉えるため、低照度最適化アルゴリズムとNIR対応ハードウェアが連動します。',
      sub1: '危険資産指定',
      icon1: IconWarningGray,
      sub2: '対応方法設定',
      icon2: IconBellGray,
      image: image3,
    },
    {
      title: '悪天候でも安定性能維持',
      desc: '雪や雨などの複雑な気象条件でも車両追跡性能を維持するため、気象変化に適応するディープラーニングベースのフィルタリングアルゴリズムを適用します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: '屋内エリアの人流同時分析',
      desc: '駐車場隣接の屋内空間はFisheyeカメラで顧客の人流を分析。駐車場と店舗の連動分析で商業活用価値を高めます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      theme: '運用効率と危険検知の自動化',
      title: '車両出入りトラフィック分析',
      desc: '出入り口の車両統計を自動収集し、時間帯別の混雑度を予測。運営時間最適化や設備改善の根拠データを提供します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '逆走検知とアラーム',
      desc: '車両が指定進行方向と逆に動く場合、即時アラームを発して危険状況に迅速対応。<br/><br/> • 特定エリアで逆方向に移動する物体を検知<br/><br/> • サービスエリア出口などで逆走検知可能<br/><br/> • 逆走発生時のアラーム機能を提供 (モバイル、管制センター連携)',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '長期放置車両分析',
      desc: '出入り口の迅速な通路で長時間停止する歩行者を検知し、アラームを発して事故リスクを防止。車両と歩行者の相互作用リスクも分析します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image8,
    },
    {
      title: '映像ROIで性能最適化・プライバシー保護',
      desc: '必要な画面のみROI（注目領域）を設定し、不要な映像を除去。演算速度を向上させ、重要エリアを非識別化してプライバシーを守ります。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウドデータ保存',
      icon2: IconCloudCheckGray,
      image: image9,
    },
  ],

  subfunc: {
    title: '多様な機能',
    desc: '医療廃棄物の管理では気を抜けません。わずかな油断とミスでも重大な医療事故につながる可能性があります。そのため、非常に精密な管理と安全性の確保が必要です。<br/>ORBROは安全かつ効率的な医療施設構築のために多様な機能を提供します。',

    data: [
      { icon: IconBinocularsGray, title: 'PTZ車両追跡', desc: '高倍率PTZで広範囲追跡。' },
      { icon: IconChartBarGray, title: 'AI物体認識', desc: '車両・歩行者を自動識別。' },
      { icon: IconClockGray, title: '夜間低照度対応', desc: '暗所でも認識率維持。' },
      { icon: IconChartBarGray, title: '悪天候対応', desc: '雪雨でも正確に補正追跡。' },
      { icon: IconChartRadius, title: '屋内人流解析', desc: 'Fish-eyeで混雑分析可視化。' },
      { icon: IconRoute, title: '車両出入分析', desc: '時間別データで交通最適化。' },
      { icon: IconZoneGray, title: '不要区域映像除去', desc: 'ROI設定で性能強化＆保護。' },
      { icon: IconWarning, title: '逆走検知アラーム', desc: '逆走即時アラート通知。' },
      { icon: IconWarning, title: '長時間歩行者検知', desc: '長時間滞留を即時警告。' },
      { icon: IconDashboard, title: 'AIダッシュボード', desc: '全体流れと異常を即表示。' },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'retailOffice' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
